import React, { useMemo } from 'react';
import { StoryblokComponent, storyblokEditable } from 'gatsby-source-storyblok';
import PropTypes from 'prop-types';
import Row from '../FlexboxGrid/Row.jsx';
import Col from '../FlexboxGrid/Col.jsx';
import { renderRichTextReact } from '../../utils/storyblokRichText';
import Separator from '../../icons/star-wars-separator.svg';

const FullWidthImageWithOneColumnCaption = ({ blok }) => {
  const { description, image, title } = blok;

  // added to support italicizing "mini" in the title for Grogu product
  const titleModified = useMemo(() => {
    if (!title.includes('Grogu')) {
      return title; // Return the title as is if it doesn't include "Grogu"
    }

    // If the title includes "Grogu", wrap "mini" in <i></i>
    const parts = title.split(/(mini)/i); // Split the title into parts, keeping "mini" as a separate element
    return (
      <>
        {parts.map((part, index) =>
          part.toLowerCase() === 'mini' ? <i key={index}>{part}</i> : part
        )}
      </>
    );
  }, [title]);

  return (
    <Col {...storyblokEditable(blok)} xs={8} md={10} lg={12}>
      <Row>
        <div className="w-full">
          {image?.map((nestedBlok) => (
            <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
          ))}
        </div>
      </Row>
      <Row>
        <div className="flex flex-wrap w-full mt-[56px] sm:mt-[67px] lg:mt-[76px]">
          <p className="basis-full typography-header-s text-beige-100">{titleModified}</p>
          <div className="basis-full my-[33px] lg:my-[40px]">
            <Separator />
          </div>
          <div className="basis-full max-w-[800px] typography-body-s sm:typography-body-l">
            {blok.description && renderRichTextReact(description)}
          </div>
        </div>
      </Row>
    </Col>
  );
};

FullWidthImageWithOneColumnCaption.propTypes = {
  blok: PropTypes.any.isRequired,
};

export default FullWidthImageWithOneColumnCaption;
